import React, {Dispatch} from "react"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"
import "./defilmentBar.css"

interface defilmentBarInterface {
    currentPage: number,
    setCurrentPage: Dispatch<React.SetStateAction<number>>,
    nbrPages: number,
    dom?:string,
    totalResult:number,
    nbrForPage:number,
    scrollToTop?:boolean,
}

const DefilmentBar:React.FC<defilmentBarInterface> = ({currentPage,setCurrentPage,nbrPages,dom,nbrForPage,totalResult,scrollToTop=false}) => {
    const block = dom ? document.getElementById(dom) as HTMLDivElement : null
  
    const scrollToElement = () => {
        if (block) {
            window.requestAnimationFrame(() => {
                block.scrollIntoView({ behavior: "smooth" });
            });
        } else if (scrollToTop) {
             requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    window.scrollTo({top:0,left:0,behavior: "smooth"})
                });
            });
        }
    };

    const clickPage = (nbrPage:number) => {
        if(nbrPage <= nbrPages) {
            setCurrentPage(nbrPage )
            scrollToElement()
        }
    }

    const clickLeftPage = () => {
        if(currentPage != 1) {
            setCurrentPage(currentPage-1)
            scrollToElement()
        }
    }
    const clickRightPage = () => {
        if(currentPage < nbrPages) {
            setCurrentPage(currentPage+1)
            scrollToElement()
        }
    }

    return (
        <>
        <div className="scrollPage">
                
            <FiChevronLeft className="scrollLeft lowOpacityHover pointer" size={35} onClick={clickLeftPage} style={{color: "#1a1a1a" ,...(currentPage === 1 && {opacity:0,cursor:'default'})}}/>
                <div className={`circleButton midTitle ${currentPage ===1 ? 'selected ' : ' pointer'}`} onClick={() => clickPage(1)}>1</div>
                
                { currentPage > 3 && <div className="thirdPoint " >{"..."}</div> }

                {     
                    currentPage === 1 ?
                        nbrPages > 1 &&  <div className='circleButton midTitle pointer' onClick={() => clickPage(2)}>2</div>
                    :   currentPage === nbrPages ? 
                            <>
                            {currentPage-1 !== 1 && <div className='circleButton midTitle pointer' onClick={() => clickPage(currentPage-1)}>{currentPage-1}</div>}
                            <div className='circleButton selected midTitleBold' onClick={() => clickPage(currentPage)}>{currentPage}</div>
                            </>
                        :
                            <>
                                {currentPage-1 !== 1 &&  <div className='circleButton midTitle pointer' onClick={() => clickPage(currentPage-1)}>{currentPage-1}</div>  }
                                <div className='circleButton selected midTitleBold' onClick={() => clickPage(currentPage)}>{currentPage}</div>
                                {currentPage+1 <= nbrPages && <div className='circleButton midTitle pointer' onClick={() => clickPage(currentPage+1)}>{currentPage+1}</div>}
                            </> 

                }
                { currentPage < nbrPages -2 && <div className="thirdPoint" >{"..."}</div>}
                { currentPage < nbrPages -1 && <div className='circleButton midTitle pointer' onClick={() => clickPage(nbrPages)}>{nbrPages}</div>
                 }

                <FiChevronRight className="scrollRight  lowOpacityHover pointer" size={35} onClick={clickRightPage} style={{color:"#1a1a1a",...(currentPage >= nbrPages && {opacity:0,cursor:'default'}) }}/>
            </div>
            {totalResult > 1 && <div className="infoScrollPage smallText">
                {`Résultats ${(currentPage-1)*nbrForPage+1} - ${Math.min(currentPage*nbrForPage,totalResult)} sur ${totalResult}`}
            </div>}
        </>
    )
}


export default DefilmentBar